// frontend/src/config/appRoutes.js
// Top-level navigable routes used by the landing-page "default page" dropdown.
// Derived from the Main section + primary group entry points in navConstants.jsx.
// Update this list when groups are added or removed from the sidebar.

export const APP_ROUTES = [
  { key: 'dashboard',           label: 'dashboard',           path: '/' },
  { key: 'navMyHours',          label: 'navMyHours',          path: '/my-hours' },
  { key: 'scan',                label: 'scan',                path: '/scan' },
  { key: 'tasks',               label: 'tasks',               path: '/todos' },
  { key: 'navComms',            label: 'navComms',            path: '/comms' },
  { key: 'navShows',            label: 'navShows',            path: '/productions' },
  { key: 'navItems',            label: 'navItems',            path: '/items' },
  { key: 'navNetwork',          label: 'navNetwork',          path: '/network' },
  { key: 'documents',           label: 'documents',           path: '/documents' },
  { key: 'navOverview',         label: 'navOverview',         path: '/financial' },
  { key: 'navUsers',            label: 'navUsers',            path: '/users' },
  { key: 'navSettings',         label: 'navSettings',         path: '/admin' },
  { key: 'navCalendarSchedule', label: 'navCalendarSchedule', path: '/calendar' },
]

export const DEFAULT_LANDING = '/'

export function getRouteByKey(key) {
  return APP_ROUTES.find(r => r.key === key) || null
}
